import React from 'react'

import Step from '../../../../../../features/components/Forms/StepForm/Step'
import CampaignNameFields from './CampaignNameFields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

const CampaignNameStep = ({ formik }) => {
  const drawerFormClasses = useDrawerFormStyles()

  return (
    <Step stepTitle="What is the name of the campaign?">
      <section className={drawerFormClasses.section}>
        <CampaignNameFields formik={formik} />
      </section>
    </Step>
  )
}

export default CampaignNameStep
